import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TAGLAMINARIA extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAG LAMINA (Laminaria digitata)</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li>
              <span className="label">1. Gazette Notification number and Date:</span>{" "}
              S.O.1574(E) Dated 25-03-2026
            </li>

            <li>
              <span className="label">2. Title of Biostimulant:</span>{" "}
              (54) Seaweed (Laminaria digitata) extract 10% (Liquid)
            </li>

            <li>
              <span className="label">3. Composition:</span>
              <ul>
                <li>(i) Seaweed (Laminaria digitata) extract per cent. by weight, minimum: 10.0</li>
                <li>(ii) Water per cent. by weight: QS</li>
                <li>(iv) Total (per cent.): 100.0</li>
              </ul>
            </li>

            <li>
              <span className="label">4. Crop:</span> Chilli
            </li>

            <li>
              <span className="label">5. Doses:</span>
              <ul>
                <li>Chilli: Four foliar applications at 625 ml/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>

          <h4>टैग लैमिना</h4>

          <ul>
            <li>
              <span className="label">1. राजपत्र अधिसूचना संख्या और दिनांक:</span>{" "}
              S.O.1574(E) दिनांक 25-03-2026
            </li>

            <li>
              <span className="label">2. जैव उत्तेजक का शीर्षक:</span>{" "}
              (54) समुद्री शैवाल (लैमिनारिआ डिजिटाटा) अर्क 10% (तरल)
            </li>

            <li>
              <span className="label">3. संरचना:</span>
              <ul>
                <li>(i) समुद्री शैवाल (लैमिनारिआ डिजिटाटा) अर्क (वजन के अनुसार प्रतिशत), न्यूनतम: 10.0</li>
                <li>(ii) पानी (वजन के अनुसार प्रतिशत): क्यु.एस.</li>
                <li>(iv) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>

            <li>
              <span className="label">4. फसल:</span> मिर्च
            </li>

            <li>
              <span className="label">5. खुराक:</span>
              <ul>
                <li>मिर्च: 625 मिली/हेक्टेयर की दर से चार बार पत्तियों पर छिड़काव</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>

          <h4>टॅग लॅमिना</h4>

          <ul>
            <li>
              <span className="label">1. राजपत्र अधिसूचना क्रमांक आणि दिनांक:</span>{" "}
              S.O.1574(E) दिनांक 25-03-2026
            </li>

            <li>
              <span className="label">2. जैव-उत्तेजकाचे शीर्षक:</span>{" "}
              (54) सागरी शैवाल (लैमिनारिआ डिजिटाटा) अर्क 10% (द्रवरूप)
            </li>

            <li>
              <span className="label">3. रचना:</span>
              <ul>
                <li>(i) सागरी शैवाल (लैमिनारिआ डिजिटाटा) अर्क (वजनानुसार टक्केवारी), किमान: 10.0</li>
                <li>(ii) पाणी (वजनानुसार टक्केवारी): क्यु.एस.</li>
                <li>(iv) एकूण (टक्केवारी): 100.0</li>
              </ul>
            </li>

            <li>
              <span className="label">4. पीक:</span> मिरची
            </li>

            <li>
              <span className="label">5. मात्रा:</span>
              <ul>
                <li>मिरची: 625 मि.ली./हेक्टर या प्रमाणात चार वेळा पानांवर फवारणी</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    );
  }
}